import React, { useState, useRef, useEffect } from "react";
import { LoadingSpinner } from "../../../icons/LoadingSpinner";
import DocumentTypeSVG from "../../../icons/PostYourProperty/DocumentTypeSVG";
import PDFViewer from "./PDFViewer";
interface FileObject {
  id?: string;
  filename?: string;
}

interface props {
  maxAllowed?: number;
  handleChange: any;
  path?: any;
  mode?: string;
  owner_service_type: string;
  property_uuid: string;
  allowedMimeTypes?: any;
  showDefaultSVG?: boolean;
  defaultText?: string;
  data: FileObject[];
}

const CustomMultiplePDFViewer = ({
  data,
  maxAllowed = 10,
  handleChange,
  owner_service_type,
  property_uuid,
  path,
  showDefaultSVG = true,
  defaultText = "No KYC Documents Uploaded",
  allowedMimeTypes = [""],
  mode = "multiple-doc-viewer",
}: props) => {
  const [selectedfile, setSelectedFile] = useState<FileObject[]>(
    data === undefined ? [] : data
  );

  const [loading, setLoading] = useState(false);
  const [clickedFile, setClickedFile] = useState<any>(
    data === undefined ? "" : data[0]
  );

  useEffect(() => {
    if (handleChange) {
      handleChange(selectedfile);
    }
  }, [selectedfile]);

  return (
    <div className="w-full ">
      <div className=" bg-brand-bgLightGrey w-full ">
        {mode !== "sidebar" && (
          <div className="border border-dashed h-full   py-7 px-8 flex  items-center  justify-center">
            {loading ? (
              <LoadingSpinner className="h-[160px]" />
            ) : (
              <>
                {selectedfile?.length > 0 ? (
                  <div className="grid grid-cols-1 mobile:grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-3 mid:grid-cols-4 gap-x-5 gap-y-8">
                    {selectedfile.map((image, index) => (
                      <div
                        onClick={() => {
                          setClickedFile(image);
                        }}
                        className="max-w-[181px] relative max-h-[160px] bg-brand-bgBlack hover:cursor-pointer"
                        key={index}
                      >
                        {image?.filename?.match(/.(jpg|jpeg|png|gif|svg)$/i) ? (
                          <img
                            src={`${process.env.NEXT_PUBLIC_IMAGIX_URL}/${image?.id}`}
                            className="h-full w-full opacity-50"
                            alt=""
                          />
                        ) : (
                          <div
                            className={`w-[181px] h-[160px] ${
                              clickedFile?.id === image?.id
                                ? "bg-brand-bgLightGrey"
                                : "bg-white"
                            }  border`}
                          >
                            <DocumentTypeSVG className="w-[170px] h-[110px] opacity-70" />
                            <p className="font-openSans text-center  break-words max-w-[180px]  absolute w-full font-semibold text-web-body-md truncate px-2 leading-4 text-brand-bgBlack ">
                              {image?.filename}
                            </p>
                          </div>
                        )}
                      </div>
                    ))}
                  </div>
                ) : (
                  <div className="flex flex-col items-center justify-center h-[160px]">
                    <p className="font-openSans text-center font-normal text-web-body-md leading-4 text-brand-textLightGrey">
                      {defaultText}
                    </p>
                  </div>
                )}
              </>
            )}
          </div>
        )}

        <div className="mt-4">
          {selectedfile?.length > 0 &&
            (clickedFile?.filename?.match(/.(jpg|jpeg|png|gif|svg)$/i) ? (
              <img
                src={`${process.env.NEXT_PUBLIC_IMAGIX_URL}/${clickedFile?.id}`}
                className="h-full w-full opacity-50"
                alt=""
              />
            ) : (
              <PDFViewer
                pdf_url={`${process.env.NEXT_PUBLIC_IMAGIX_URL}/${clickedFile?.id}`}
              />
            ))}
        </div>
      </div>
    </div>
  );
};

export default CustomMultiplePDFViewer;
